<div class="row mar-lft-rgt-0 font-16" [hidden]="!subRadioDisplay">
    <div class="col-sm-12 pad-15">
        <mat-radio-group (change)="onSubButtonChange($event)">
            <mat-radio-button *ngFor="let button of subtypes;" [value]="button" [checked]="button.checked"
            >{{button.type}}
            </mat-radio-button>&nbsp;&nbsp;
        </mat-radio-group>
    </div>
</div>

<div class="row mar-lft-rgt-0">
    <div class="col-md-12 pad-15">
        <div class="height-40" [hidden]="categoryLoaded">
            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;" [disabled]="ticket.isDisabled"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                [hidden]="!categoryLoaded">
            <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
    </div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="row col-sm-12" style=" margin-left: 5px;">
        <div class="col-sm-6" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
            <input [ngClass]="field.isQuestion? ' ' : 'col-sm-12'" *ngSwitchCase="'1'" [hidden]="field.isQuestion" type="text" class="form-control radius-0 font-13 marginTop" placeholder="{{field.fieldName}}"[(ngModel)]="field.value">
            <div class="form-group col-sm-6" *ngSwitchCase="'4'">
                <mat-form-field class="col-sm-2 matcss">
                    <mat-label>{{field.fieldName}}</mat-label>
                    <mat-select [(ngModel)]="field.value">
                        <mat-option *ngFor="let opt of field.values" [value]="opt"
                        >{{opt}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-group  marginTop" *ngSwitchCase="'1'" [hidden]="!field.isQuestion">
                <div class="row margin2">

                    <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
                    <div class="col-sm-5">
                        <div class="form-group">
                            <input type="text" class="form-control radius-0 font-13 " [(ngModel)]="field.value" (keypress)="blockSpecialChar($event)" maxlength="200"/>
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-group  marginTop" *ngSwitchCase="'7'" [hidden]="!field.isQuestion">
                <div class="row margin2">

                    <label class="col-sm-6 col-form-label label1 ">{{field.fieldName}}</label>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <textarea class="form-control radius-0 font-13 heighttxt" [(ngModel)]="field.value"
                                      (keypress)="blockSpecialChar($event)" maxlength="200" mwlResizable
                                      [enableGhostResize]="false"
                                      resizeCursorPrecision="100"
                                      [resizeEdges]="{bottom: true, right: false, top: false, left: false}"
                                      (resizeEnd)="onResizeEnd($event)"
                                      [style.height.px]="height"></textarea>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-6" *ngSwitchCase="'2'">
                <div class="row margin2 date-type">
                    <div class="form-group">
                        <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                               placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                               [owlDateTime]="dt" [min]="min">
                        <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
                    </div>
                </div>
            </div>
            <div class="col-sm-6" *ngSwitchCase="'5'">
                <div class="row margin2 date-type">
                    <div class="form-group">
                        <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                               placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                               [owlDateTime]="dt">
                        <owl-date-time [pickerType]="'timer'" #dt></owl-date-time>
                    </div>
                </div>
            </div>
            <div class="col-sm-6" *ngSwitchCase="'6'">
                <div class="row margin2 date-type">
                    <div class="form-group">
                        <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                               placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                               [owlDateTime]="dt" [min]="min">
                        <owl-date-time #dt></owl-date-time>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class=" mar-lft-rgt-0">
    <div class="row" style=" margin-left: 15px;">

        <div class="row margin2 date-type">
            <div class="form-group">
                <input class="form-control radius-0 font-13 marginTop widthBox" placeholder="Schedule Start Date"
                       [(ngModel)]="scheduleStartDate" readonly [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [min]="min">
                <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
            </div>
        </div>

        <div class="row margin2 date-type">
            <div class="form-group">
                <input class="form-control radius-0 font-13 marginTop widthBox" placeholder="Schedule Duration(in min)"
                       [(ngModel)]="scheduleDuration" type="number" min="0">
            </div>
        </div>

        <div class="form-group">
            <div class="row margin2 date-type">
                <div class="form-group">
                    <input class="form-control radius-0 font-13 marginTop widthBox"
                           placeholder="Planned Activity Start Date/Time" readonly [(ngModel)]="plannedStartDt"
                           [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [min]="min">
                    <!--[ngModelOptions]="{standalone: true}" (ngModelChange)="fromDateChanged()"-->
                    <owl-date-time #dt1></owl-date-time>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="row margin2 date-type">
                <div class="form-group">
                    <input class="form-control radius-0 font-13 marginTop widthBox"
                           placeholder="Planned Activity End Date/Time" readonly [(ngModel)]="plannedEndDt"
                           [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [min]="min">
                    <owl-date-time #dt2></owl-date-time>
                </div>
            </div>
        </div>

        <div class="row margin2 date-type">
            <div class="form-group">
                <button type="button" (click)="checkConflicket()" class="btn btn-primary radius-0 font-13 marginTop ">
                    Check conflict
                </button>
            </div>
        </div>


    </div>

</div>
<div class="row mar-lft-rgt-0">
    <div class="col-md-7  ">
        <div class="row mar-lft-rgt-0 configTable" [hidden]="!plannedTicketDisplay">
            <div class="col-md-12 search-box">
                <table class="table">
                    <thead class="thead-light">
                    <tr class="rsdb-head">
                        <th>Sl No</th>
                        <th>Ticket_id</th>
                        <th>Status</th>
                        <th>Planned Activity Start Date/Time</th>
                        <th>Planned Activity End Date/Time</th>
                        <th>Schedule Start Date</th>
                        <th>Schedule Duration</th>

                    </tr>
                    </thead>
                    <tbody class="rsdb-body">
                    <tr *ngFor="let plannedTicketArrs of plannedTicketArr;let i = index;">
                        <td>{{ i + 1 }}</td>
                        <td>{{plannedTicketArrs.ticket_id}}</td>
                        <td>{{plannedTicketArrs.status}}</td>
                        <td>{{plannedTicketArrs.planned_activity_start_dt}}</td>
                        <td>{{plannedTicketArrs.planned_activity_end_dt}}</td>
                        <td>{{plannedTicketArrs.schedule_start_date}}</td>
                        <td>{{plannedTicketArrs.schedule_duration}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>


        <div class="row mar-lft-rgt-0">
            <div class="col-md-12 search-box" [hidden]="!displayed">
                <table class="table">
                    <thead class="thead-light">
                    <tr class="rsdb-head">
                        <th>Asset No</th>
                        <th>Location</th>
                        <th>Asset Owner</th>
                        <th>Type</th>
                        <th>Make</th>
                        <th>Model</th>
                        <th>Asset Description</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody class="rsdb-body">
                    <!--*ngFor="let asset of Tickets"-->
                    <tr *ngFor="let asset of Tickets; let i = index;">
                        <td>{{asset['Asset ID']}}</td>
                        <td>{{asset['Location']}}</td>
                        <td>{{asset['Asset Owner']}}</td>
                        <td>{{asset['Type']}}</td>
                        <td>{{asset['Model']}}</td>
                        <td>{{asset['Model']}}</td>
                        <td>{{asset['Asset Description']}}</td>
                        <!--<td><button (click)="removeAsset(i)"><mat-icon>delete</mat-icon></button></td>-->
                        <td>
                            <mat-icon (click)="removeAsset(i)">delete_outline</mat-icon>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div class="row mar-lft-rgt-0" [hidden]="!displayed">
            <button type="button" class="btn btn-success radius-0 font-13" (click)="openModal(content)">
                Attach
                CI
            </button>
        </div>
        <!--=========================== reactive problem search ==============================================-->
        <div class="row mar-lft-rgt-0">
            <div class="col-md-8 search-box" >
                <!--                        <mat-form-field class="example-chip-list">-->
                <mat-chip-list #chipList>
                    <mat-chip color="primary" selected *ngFor="let data of addedTicket"
                              [selectable]="selectable"
                              [removable]="removable" (removed)="removeReactiveProblemData(data)">
                        {{data}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur">
                    <!--(matChipInputTokenEnd)="add($event)"-->
                </mat-chip-list>
                <!--                        </mat-form-field>-->
                <!--<input type="search" class="search-field" placeholder="Search" [(ngModel)]="searchField">-->

            </div>
            <div class="col-md-4" style="float: right" >
                <button type="button" class="btn btn-success radius-0 font-13"
                        (click)="ticketModal(contentData)">
                    Attach
                    Ticket
                </button>
            </div>
        </div>
        <div class="row mar-top-9">
            <div class="form-group col-md-6">
                <input type="text" class="form-control radius-0 font-13 "
                       placeholder="Enter Requester info (Ex. Name, phone number , email etc)"
                       [(ngModel)]="name" title="{{name}}" readonly
                       [ngClass]="isBlankRequester?'error-field':''">
                <button [hidden]="isLowestLevel" type="button"
                        class="btn btn-primary font-13 radius-0"
                        (click)="openTicketDetailsModal()">Select Requester
                </button>
            </div>
        </div>
        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13"
                   placeholder="Ticket Title" [(ngModel)]="desc" maxlength="50"
                   (input)="searchFaq($event.target.value)" [ngClass]="isBlankDesc?'error-field':''">
            <div class="warning-msg">
                *maximum 50 characters
            </div>
        </div>
        <div class="form-group">
                    <textarea class="form-control radius-0 font-13 edge-textarea brief-desc"
                              placeholder="Business Justification" [(ngModel)]="brief" maxlength="1000"
                              [ngClass]="isBlankLong?'error-field':''" mwlResizable
                              [enableGhostResize]="false"
                              resizeCursorPrecision="100"
                              [resizeEdges]="{bottom: true, right: false, top: false, left: false}"
                              (resizeEnd)="onResizeEnd($event)"
                              [style.height.px]="height"></textarea>
            <div class="warning-msg">
                *maximum 1000 characters
            </div>
        </div>
        <div class="form-group" [hidden]="hideClaim">
            <input type="text" class="form-control radius-0 font-13"
                   placeholder="Enter Claim No" [(ngModel)]="claimNo" [ngClass]="isBlankClaim?'error-field':''">
        </div>
    </div>
    <div class="col-md-5">
        <mat-tab-group #tab class="tabset" [selectedIndex]="selectedTab">
            <mat-tab label="Recent Tickets" id="tab1">
                <div class="card">
                    <div class="card-body card-body-grid" style="height:237px;overflow: auto;padding:3px;">
                        <table class="table">
                            <thead class="thead-light">
                            <tr class="rsdb-head">
                                <th>Ticket Id</th>
                                <th>Title</th>
                                <!--                                        <th>Desc</th>-->
                                <th>Status</th>
                                <th>Created Date</th>
                            </tr>
                            </thead>
                            <tbody class="rsdb-body">
                            <tr *ngFor="let rsdb of rsdbData" (click)="clickRsdb(rsdb.id)">
                                <td>{{rsdb.ticket_id}}</td>
                                <td>{{rsdb.tName}}</td>
                                <!--                                        <td>{{rsdb.longDesc}}</td>-->
                                <td>{{rsdb.ticket_status}}</td>
                                <td>{{rsdb.createdate | date:'medium'}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Knowledge Map" id="tab2">
                <div class="card">
                    <div class="card-body card-body-grid cardbody"
                         style="height:237px;overflow: auto;padding:3px;">
                        <mat-accordion>
                            <mat-expansion-panel id="search_panel_{{data.id}}" *ngFor="let data of searchDtls"
                                                 (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <ng-template #tipContent>
                                            <div [innerHTML]="data.searchword"></div>
                                        </ng-template>
                                        <div class="blue" [ngbTooltip]="tipContent" container="body"
                                             [innerHTML]="(data.searchword.length > 70)? (data.searchword | slice:0:70)+'...':(data.searchword)"></div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <hr class="mar-top-0">
                                <p class="faq-ans">{{data.answers}}</p>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="col-sm-6 pad-15 text-center">
        <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"
                                 (uploadError)="onFileError($event)"
                                 (complete)="onFileComplete($event)"
                                 (onFileAttach)="onFileAttach()"
                                 (onFileRemove)="onRemove()"
                                 (dataLoaded)="onUpload($event)"></app-material-fileupload>
    </div>
    <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}</div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
        <select class="custom-select" [(ngModel)]="impact">
            <option *ngFor="let map of impacts" [value]="map.id">{{map.name}}</option>
        </select>
    </div>
    <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
        <select class="custom-select" [(ngModel)]="urgency">
            <option *ngFor="let map of urgencies" [value]="map.id">{{map.name}}</option>
        </select>
    </div>
    <div class="col-sm-4 pad-15">
        <!--<input class="form-control radius-0 font-13" type="text" [(ngModel)]="priority" placeholder="Priority" readonly>-->
        <select class="custom-select" [(ngModel)]="selectedPriority">
            <option *ngFor="let priority of priorityArr" [value]="priority.id">{{priority.priority}}</option>
        </select>
    </div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="createTicket()">Create
        </button>
    </div>
    <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="resetField()">Reset
        </button>
    </div>
</div>
<ng-template #contentData let-modal let-c="close">
    <div class="modal-header">
        <h4 class="modal-title">Search ticket to Attach</h4>
        <button type="button" class="close" aria-label="Close" (click)="c()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body  overY-hidden">
        <div class="shadow  ">
            <div class="row mar-lft-rgt-0">
                <input type="text" class="form-control font-13 col-sm-6 radius-0 mar-bot-10" [(ngModel)]="searchTid"
                       id="ticketId"
                       placeholder="Enter Ticket Id">&nbsp;
                <button type="button" class="btn btn-primary font-13 radius-0 col-sm-2 mar-bot-10"
                        (click)="searchTicket()">Search
                    Ticket
                </button>
                <div class="height-40 col-sm-2 mar-bot-10" [hidden]="ticketIdSearchLoaded">
                    <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                </div>
            </div>
        </div>

        <span class="totalitem"><b>Total items: </b> {{totalItems}}</span>
        <div class="col-sm-12 height-250 mar-top-15">
            <angular-slickgrid gridId="grid2"
                               [columnDefinitions]="ticketColumnDefinitions"
                               [gridOptions]="gridOptions2"
                               (onAngularGridCreated)="angularGridReady2($event)"
                               (sgOnSelectedRowsChanged)="handleSelectedRowsChanged2($event.detail.eventData, $event.detail.args)"
                               [dataset]="dataset">
            </angular-slickgrid>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-block radius-0 font-13   mar-top-9"
                (click)="addTicket()">Add Ticket ({{ticketCount}})
        </button>
        <button type="button" class="btn btn-danger btn-block radius-0 font-13 mar-top-9"
                (click)="saveReactiveProblemData()">Save
        </button>
        <!--<button type="button" class="btn btn-primary btn-block" (click)="c()">Close</button>-->
    </div>
</ng-template>
<ng-template #content let-modal let-c="close">
    <div class="modal-header">
        <h4 class="modal-title">Asset management</h4>
        <button type="button" class="close" aria-label="Close" (click)="c()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group row">
            <div class="col-md-3">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected"
                        (change)="onMasterChange($event.target.selectedIndex)">
                    <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
                </select>
            </div>
            <div class="col-md-3">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="columnNameSelected"
                        (change)="onClientChange($event.target.selectedIndex)">
                    <option *ngFor="let column of columnDataObj"
                            [value]="column.columnId">{{column.columnName}}</option>
                </select>
            </div>
            <div class="col-md-3">
                <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"
                       placeholder="Digital Asset value">
            </div>
            <div class="col-md-3">
                <button type="button" class="btn btn-primary radius-0 font-13" (click)="submitAssetData()">Submit
                </button>
            </div>
        </div>
        <div class="overflow-auto">
            <angular-slickgrid gridId="grid1"
                               [columnDefinitions]="columnDefinitions"
                               [gridOptions]="gridOptions"
                               (onAngularGridCreated)="angularGridReady($event)"
                               gridWidth="4000"
                               gridHeight="300"
                               (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                               [dataset]="data">
            </angular-slickgrid>
        </div>
    </div>
    <div class="modal-footer">
        <ngb-pagination [collectionSize]="collectionSize" [maxSize]="5" (pageChange)="onPageChange($event)"
                        [(page)]="page"
                        [pageSize]="pageSize" aria-label="Default pagination"></ngb-pagination>
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="saveData()" style="
    margin-top: 8px;">Add Asset ({{assetCount}})
        </button>
        <button type="button" class="btn btn-warning btn-block radius-0 font-13" (click)="c()">Save</button>
    </div>
</ng-template>
<ng-template #loginName>
    <!--<input class="form-control radius-0 font-13" type="text" [(ngModel)]="empId" placeholder="Enter PS Number"-->
    <!--(keydown.enter)="changeId($event)">-->
    <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" placeholder="Enter PS Number OR Name"
               [(ngModel)]="userSelected"
               matInput [formControl]="searchUser"
               [matAutocomplete]="auto" (keydown.enter)="changeId($event)">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngIf="isLoading" class="is-loading">
                <mat-spinner diameter="50"></mat-spinner>
            </mat-option>
            <ng-container *ngIf="!isLoading">
                <mat-option *ngFor="let user of userDtl" [value]="user.name" class="matFont">
                    {{ user.name }}
                </mat-option>
            </ng-container>
        </mat-autocomplete>
    </div>
</ng-template>
<ng-template #groupSelect>
    <select class="custom-select radius-0 font-13" [(ngModel)]="userGroupSelected">
        <option *ngFor="let group of userGroups" [value]="group.groupId">{{group.grpName}}</option>
    </select>
</ng-template>

<notifier-container></notifier-container>
